import {loaders} from '../utils/loaders';

export function getUsers () {
    // So we see updates on the search list pages
    // clear the cache.
    // Not super performant so... meh?
    loaders.all_users.clear(1);
    loaders.all_orgs.clear(1);
    return Promise.all([
        loaders.all_users.load(1),
        loaders.all_orgs.load(1)
    ]);
}
